<template>
    <div class="container text-center">
        <div class="row">
            <div class="col">
                <h1 style="margin-top: 100px;">404 Not Found</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

    }
</script>

<style>

</style>